import * as ActionTypes from "./ActionTypes";

export const ChangeAdminLoginState = isLoggedIn => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_ADMIN_LOGIN_STATE,
    isLoggedIn: isLoggedIn
  };
};

export const SetAdminInfo = info => {
  return {
    type: ActionTypes.NAVIGATION_SET_ADMIN_INFO,
    info: info
  };
};

export const ChangeAdminLoadingIndicator = isLoading => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_ADMIN_LOADING_INDICATOR,
    isLoading: isLoading
  };
};

export const ChangeCurrentAdminScreen = screenID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_CURRENT_ADMIN_SCREEN,
    screenID: screenID
  };
};

export const ChangeSportPrematch = sportID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_SPORT_PREMATCH,
    sportID: sportID
  };
};

export const ChangeSportLive = sportID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_SPORT_LIVE,
    sportID: sportID
  };
};

export const ChangeCalendarItem = (calendarItemID, date) => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_CALENDAR_ITEM,
    calendarItemID: calendarItemID,
    chosenDate: date
  };
};

export const ChangeMostPlayedButtonItem = buttonID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_MOST_PLAYED_BUTTON,
    mostPlayedButtonID: buttonID
  };
};

export const ChangeCategoryItem = categoryID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_COUNTRY,
    categoryID: categoryID
  };
};

export const ChangeLeagueItem = leagueID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_LEAGUE,
    leagueID: leagueID
  };
};

export const ChangeLastUsedPicker = pickerID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_LAST_USED_PICKER,
    pickerID: pickerID
  };
};

export const ChangeCurrentLiveExtraBetsID = betsID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_CURRENT_LIVE_EXTRA_BETS_ID,
    betsID: betsID
  };
};

export const SetPayoutReceiptNumber = receiptNumber => {
  return {
    type: ActionTypes.NAVIGATION_SET_PAYOUT_RECEIPT_NUMBER_FOR_DETAILS,
    receiptNumber: receiptNumber
  };
};

export const SetCanShowExtraLiveBets = canShow => {
  return {
    type: ActionTypes.NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_LIVE,
    canShow: canShow
  };
};

export const SetCanShowExtraPrematchBets = canShow => {
  return {
    type: ActionTypes.NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_PREMATCH,
    canShow: canShow
  };
};

export const SetMatchForStatisticsID = matchID => {
  return {
    type: ActionTypes.NAVIGATION_SET_MATCH_FOR_STATISTICS_ID,
    matchID: matchID
  };
};

export const ChangeCurrentPrematchExtraBetsID = betsID => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_CURRENT_PREMATCH_EXTRA_BETS_ID,
    betsID: betsID
  };
};

export const ChangeCurrentBetGroups = betGroups => {
  return {
    type: ActionTypes.NAVIGATION_CHANGE_CURRENT_BET_GROUPS,
    betGroups: betGroups
  };
};

export const SetShouldQuickCloseExtraBets = shouldClose => {
  return {
    type: ActionTypes.NAVIGATION_SET_SHOULD_QUICK_CLOSE_EXTRA_BETS,
    shouldClose: shouldClose
  };
};

export const SetTicketNumberForDetails = ticketNumber => {
  return {
    type: ActionTypes.NAVIGATION_SET_TICKET_FOR_DETAILS,
    ticketNumber: ticketNumber
  };
};

export const SetTerminalActionsActiveButton = actionID => {
  return {
    type: ActionTypes.NAVIGATION_SET_TERMINAL_ACTIONS_ACTIVE_BUTTON,
    activeAction: actionID
  };
};

export const SetIsShowingBonusInfo = showsBonus => {
  return {
    type: ActionTypes.NAVIGATION_SET_IS_SHOWING_BONUS_INFO,
    showsBonus: showsBonus
  };
};

export const SetIsShowingSystemCombinationsPopup = showSystemInfo => {
  return {
    type: ActionTypes.NAVIGATION_SET_IS_SHOWING_SYSTEM_INFO,
    showSystemInfo: showSystemInfo
  };
};



// WEBPACK FOOTER //
// ./src/ReduxStore/Actions/NavigationActions.js